const empty = () => {
    // do nothing
};
const subscribers: { [id: string] : any } = {};
let muteExcept: string[]|null;

function objectify(subscriber: string): any {
    return { _id: subscriber, detachEvent: empty, removeEventListener: empty };
}

function notMuted(sub: string) {
    return muteExcept == null || muteExcept.indexOf(sub) >= 0;
}

function checkTelProtocol(e: any): boolean {
    if (e.target.activeElement.protocol === 'tel:') {
        return true;
    } else {
        return false;
    }
}

export function publish(topic: string, data?: any): void {
    topic = topic.toLowerCase();
    for (const sub in subscribers) {
        if (notMuted(sub)) {
            subscribers[sub].triggerHandler(topic, { data });
        }
    }
}

export function subscribe(subscriber: string, topic: string, callback: (any) => void) : void {
    const s = objectify(subscriber);
    if (subscribers[s._id] === undefined) {
        subscribers[s._id] = $(s);
    }
    if (topic == null) {
        throw new Error('cannot call subscribe without providing a topic');
    }
    topic = topic.toLowerCase();
    subscribers[s._id].unbind(topic).bind(topic, (e, data) => {
        e = $.extend(e, data);
        callback.call(this, e);
    });
}

export function subscribeOnce(subscriber: string, topic: string, callback: (...any) => void): void {
    // Unsubscribe automatically after topic is published once
    subscribe(subscriber, topic, (...args) => {
       callback(...args);
       unsubscribe(subscriber, topic);
    });
}

export function unsubscribe(subscriber: string, topic?: string): void {
    const s = objectify(subscriber);
    if (subscribers[s._id] === undefined) { return; }

    if (topic == null) {
        subscribers[s._id].unbind();
        delete subscribers[s._id];
    } else {
        topic = topic.toLowerCase();
        subscribers[s._id].unbind(topic);
    }
}

export function mute(except: string|string[]): void {
    muteExcept = except instanceof Array ? except : [except];
}

export function unmute(): void {
    muteExcept = null;
}

window.addEventListener('beforeunload', (e) => {
    if (checkTelProtocol(e)) {
        return;
    }
    for (const s in subscribers) {
        if (subscribers.hasOwnProperty(s)) {
            subscribers[s].unbind();
            delete subscribers[s];
        }
    }
});
